import { urlToImgix } from '../../helpers/utils';
export default function () {
    return function (url, _options) {
        return url ? urlToImgix(url) : '';
    };
}